import * as React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TOAST_CONTAINER, CLOSE_TIME } from '../../../constants/configs/toastrUi';

const Toastr = () =>
    <ToastContainer position="top-right" autoClose={CLOSE_TIME} style={TOAST_CONTAINER}/>;

export default Toastr;
